import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export interface UploadedImage {
    cartId?: string;
    itemId: string;
    imageId?: string;
}

export interface UploadingImage extends UploadedImage {
    fileName: string;
    fileSize: string;
    formData: FormData;
}

export interface UploadImageReturn {
    imageId: string;
    uploadedDate: string;
}

export interface FetchImageResult {
    base64: string;
    contentType: string;
}

export async function fetchVetAuthImage(
    input?: Omit<UploadedImage, 'itemId'> | null
): Promise<FetchImageResult | null> {
    const url = CWEA_ENDPOINTS.cart.fetchVetAuthImage(input?.cartId, input?.imageId ?? '');

    return await cweaClient.get<FetchImageResult>(url, { useOldFetch: true });
}

export async function uploadVetAuthImage(input?: UploadingImage | null) {
    const url = CWEA_ENDPOINTS.cart.uploadVetAuthImage(input?.cartId, input?.itemId);

    return await cweaClient.post<UploadImageReturn, FormData>(url, {
        body: input?.formData,
        useOldFetch: true,
    });
}
